export default {
  getSystemConfig: {
    method: 'get',
    url: '/client/system/config-data'
  },
  getSystemData: {
    method: 'get',
    url: '/client/system/system-data'
  },
  getLocations: {
    method: 'get',
    url: '/client/system/locations'
  }
}
